<div class="legend-list">
  @if (showFilter) {
    <button mat-raised-button color="primary" (click)="resetFilters()">
      <mat-icon>delete_sweep</mat-icon>
      <span>Reset Filters</span>
    </button>
  }

  @for (legend of this.legendItems; track legend) {
    <div>
      @if (showFilter) {
        <mat-checkbox
          [(ngModel)]="legend.visible"
          (change)="triggerChangedEvent($event)">
          <div class="legend-item">
            <div class="legend-color" [ngStyle]="{'background-color': legend.color }"></div>
            <span>{{legend.name}}</span>
          </div>
        </mat-checkbox>
      }
      @if (!showFilter) {
        <div class="legend-item-no-check">
          <div class="legend-color" [ngStyle]="{'background-color': legend.color }"></div>
          <span>{{legend.name}}</span>
        </div>
      }
    </div>
  }
</div>
